// extracted by mini-css-extract-plugin
export var button = "_6b-4";
export var hasDarkBackground = "_6b-7";
export var hasLightBackground = "_6b-6";
export var iconWrapper = "_6b-0";
export var large = "_6b-2";
export var medium = "_6b-1";
export var small = "_6b-5";
export var xsmall = "_6b-3";